import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightbulb = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.75 10.5C11.9 9.75 12.275 9.225 12.875 8.625C13.625 7.95 14 6.975 14 6C14 4.80653 13.5259 3.66193 12.682 2.81802C11.8381 1.97411 10.6935 1.5 9.5 1.5C8.30653 1.5 7.16193 1.97411 6.31802 2.81802C5.47411 3.66193 5 4.80653 5 6C5 6.75 5.15 7.65 6.125 8.625C6.65 9.15 7.1 9.75 7.25 10.5",
			stroke: "#8E8E93",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 13.5H11.75",
			stroke: "#8E8E93",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 16.5H11",
			stroke: "#8E8E93",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLightbulb);
export default ForwardRef;
